/**
 * Ordena setores irmãos por peso e nome.
 */
function ordenarSetoresIrmaos(setores) {
    return [...(setores || [])].sort((a, b) => {
        const pa = a.peso ?? 0;
        const pb = b.peso ?? 0;
        if (pa !== pb) return pa - pb;
        return (a.nome || '').localeCompare(b.nome || '', 'pt-BR');
    });
}

/**
 * Achata árvore de setores (subsetor) em ordem hierárquica (pais antes dos filhos).
 *
 * @param {Array} setores
 * @param {number} nivel
 * @returns {Array<{id, nome, nivel_hierarquico, setor_pai, setor_responsavel_id}>}
 */
export function flattenSetoresArvore(setores, nivel = 0) {
    if (!Array.isArray(setores)) return [];

    return ordenarSetoresIrmaos(setores).flatMap((setor) => {
        const nivelAtual = setor.nivel_hierarquico ?? nivel;
        const item = {
            id: setor.id,
            nome: setor.nome,
            nivel_hierarquico: nivelAtual,
            setor_pai: setor.setor_pai ?? null,
            setor_responsavel_id: setor.setor_responsavel_id ?? setor.responsavel_id ?? null,
        };

        return [item, ...flattenSetoresArvore(setor.subsetor || [], nivelAtual + 1)];
    });
}

/**
 * Rótulo para select/autocomplete — só o nome; indentação visual via `estiloOptionSetor`.
 */
export function rotuloSetorSelect(setor) {
    return setor?.nome || '';
}

/**
 * Estilo visual para <option> (indentação; nível 0 e subsetores de nível 1 em negrito).
 */
export function estiloOptionSetor(setor) {
    const n = Number(setor?.nivel_hierarquico) || 0;

    return {
        paddingLeft: `${4 + n * 10}px`,
        fontWeight: n <= 1 ? '600' : '400',
    };
}
